var _style, _path, _path2, _polyline, _polyline2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2DABE2;}\r\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:19.6078;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st3{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M570.5,600h-540c-16.5,0-30-13.5-30-30V30c0-16.5,13.5-30,30-30h540c16.5,0,30,13.5,30,30v540 C600.5,586.5,587,600,570.5,600z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M534.7,564.2H66.2c-16.5,0-30-13.5-30-30V65.8c0-16.5,13.5-30,30-30h468.4c16.5,0,30,13.5,30,30v468.4 C564.7,550.7,551.2,564.2,534.7,564.2z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "100.1,102.9 99.7,507.2 513.7,507.2 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "103.7,487.5 232.9,339.3 277,403.1 378.3,260 412.1,298.9 487.7,200.5 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M454.6,194.9L498,232c4.1,3.5,10.4,1.1,11.1-4.2l6.5-48.3c0.6-4.5-3.5-8.3-7.9-7.2l-50.3,11.4 C452.1,184.7,450.4,191.4,454.6,194.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaIcon);
export default __webpack_public_path__ + "static/media/EVA_icon.ec90d90bedaebd6e58f502345549bf88.svg";
export { ForwardRef as ReactComponent };